import SidebarContentWrapper from '@/modules/sidebar/SidebarContentWrapper';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { getAuthSnapshot } from '@/context/auth/deriveAuth';

const AdminLayout = () => {
  return <SidebarContentWrapper>
    <Outlet />
  </SidebarContentWrapper>

}

export const Route = createFileRoute('/_authenticated/_admin')({
  component: AdminLayout,
  beforeLoad: async () => {
    const { isSuperAdmin } = getAuthSnapshot();

    if (!isSuperAdmin) {
      // '/' fans out in _authenticated/index.tsx: member-care users land on their
      // own area, so this is "go home", not "go to the admin users table".
      throw redirect({
        to: '/',
      });
    }
  },
});
